/**
 * Local Date Formatter
 *
 * Centralized utility for converting Date objects to YYYY-MM-DD strings
 * using the device's local timezone (not UTC).
 *
 * Follows single responsibility principle: only handles local date string conversion.
 */
export class LocalDateFormatter {
  /**
   * Convert Date object to YYYY-MM-DD string using LOCAL timezone
   * @param date - Date object
   * @returns Date string in YYYY-MM-DD format (local timezone)
   */
  static toDateKey(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * Get today's date string in YYYY-MM-DD format using LOCAL timezone
   * @returns Today's date (YYYY-MM-DD)
   */
  static getTodayDateString(): string {
    return this.toDateKey(new Date());
  }

  /**
   * Parse YYYY-MM-DD string to Date object at midnight local time
   * @param dateKey - Date string in YYYY-MM-DD format
   * @returns Date object at midnight local time
   */
  static fromDateKey(dateKey: string): Date {
    const [year, month, day] = dateKey.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
}
